// extracted by mini-css-extract-plugin
module.exports = {"number":"NumberCircle-module--number--3bDlD","numberIcon":"NumberCircle-module--numberIcon--2h5WP","numberText":"NumberCircle-module--numberText--boe7N"};